import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DomainService {
    private readonly DOMAIN_KEY = 'domain';
    private readonly LAST_MERCHANT_KEY = 'lastSpecificMerchant';

    saveDomain(domain: string) {
        localStorage.setItem(this.DOMAIN_KEY, domain);
        if (domain && domain !== 'ALL' && !domain.includes(',')) {
            this.saveLastSpecificMerchant(domain);
        }
    }

    getDomain() {
        return localStorage.getItem(this.DOMAIN_KEY);
    }

    deleteDomain() {
        localStorage.removeItem(this.DOMAIN_KEY);
    }

    /** Último comercio específico elegido (sobrevive al logout para el próximo arranque). */
    saveLastSpecificMerchant(merchant: string) {
        if (merchant && merchant !== 'ALL' && !merchant.includes(',')) {
            localStorage.setItem(this.LAST_MERCHANT_KEY, merchant);
        }
    }

    getLastSpecificMerchant(): string | null {
        return localStorage.getItem(this.LAST_MERCHANT_KEY);
    }

    isSpecificMerchantSelected(): boolean {
        const domain = this.getDomain();
        return Boolean(domain) && domain !== 'ALL';
    }

    getSelectedMerchant(): string | null {
        const domain = this.getDomain();
        return this.isSpecificMerchantSelected() ? domain : null;
    }

    getSelectedMerchantIds(): string[] | null {
        const domain = this.getDomain();
        if (!domain) {
            return [];
        }
        if (domain === 'ALL') {
            return null;
        }
        return domain
            .split(',')
            .map((part) => part.trim())
            .filter((part) => part !== '' && part !== 'ALL');
    }
}
